// tslint:disable
/**
 * firmaCurpMs-develop
 * Versión desarrollo :: Microservicio para firma por curp
 *
 * The version of the OpenAPI document: 1.1.0-beta
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as globalImportUrl from 'url';
import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * Fuente desde donde proviene el CURP
 * @export
 * @enum {string}
 */
export enum Fuente {
    MIIC = 'MIIC',
    RIZOMA = 'RIZOMA'
}

/**
 * Petición para cifrar un contendio
 * @export
 * @interface PeticionCifrado
 */
export interface PeticionCifrado {
    /**
     * Información a cifrar
     * @type {string}
     * @memberof PeticionCifrado
     */
    data: string;
    /**
     * CVU de la persona que está firmando
     * @type {number}
     * @memberof PeticionCifrado
     */
    cvu: number;
    /**
     * Password de la persona que firma
     * @type {string}
     * @memberof PeticionCifrado
     */
    password: string;
    /**
     * 
     * @type {Fuente}
     * @memberof PeticionCifrado
     */
    fuente?: Fuente;
    /**
     * 
     * @type {TipoUsuario}
     * @memberof PeticionCifrado
     */
    tipoUsuario?: TipoUsuario;
}
/**
 * 
 * @export
 * @interface Problem
 */
export interface Problem {
    /**
     * An absolute URI that identifies the problem type.  When dereferenced, it SHOULD provide human-readable documentation for the problem type (e.g., using HTML). 
     * @type {string}
     * @memberof Problem
     */
    type?: string;
    /**
     * A short, summary of the problem type. Written in english and readable for engineers (usually not suited for non technical stakeholders and not localized); example: Service Unavailable 
     * @type {string}
     * @memberof Problem
     */
    title?: string;
    /**
     * The HTTP status code generated by the origin server for this occurrence of the problem. 
     * @type {number}
     * @memberof Problem
     */
    status?: number;
    /**
     * A human readable explanation specific to this occurrence of the problem. 
     * @type {string}
     * @memberof Problem
     */
    detail?: string;
    /**
     * An absolute URI that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced. 
     * @type {string}
     * @memberof Problem
     */
    instance?: string;
}
/**
 * Respuesta del cifrado
 * @export
 * @interface RespuestaCifrado
 */
export interface RespuestaCifrado {
    /**
     * ID del cifrado
     * @type {string}
     * @memberof RespuestaCifrado
     */
    id?: string;
    /**
     * Texto cifrado
     * @type {string}
     * @memberof RespuestaCifrado
     */
    signature?: string;
    /**
     * Datos sugeridos para generar el QR
     * @type {string}
     * @memberof RespuestaCifrado
     */
    qrData?: string;
}
/**
 * Tipo de usuario (usado en Fuente = MIIC)
 * @export
 * @enum {string}
 */
export enum TipoUsuario {
    INTERNO = 'INTERNO',
    EXTERNO = 'EXTERNO'
}

/**
 * Validación de una cadena cifrad
 * @export
 * @interface ValidacionCifrado
 */
export interface ValidacionCifrado {
    /**
     * CVU de la persona que está firmando
     * @type {string}
     * @memberof ValidacionCifrado
     */
    curp: string;
    /**
     * Información a cifrar
     * @type {string}
     * @memberof ValidacionCifrado
     */
    data: string;
    /**
     * Texto cifrado
     * @type {string}
     * @memberof ValidacionCifrado
     */
    signature: string;
}

/**
 * FirmaCurpApi - axios parameter creator
 * @export
 */
export const FirmaCurpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Método utilizado para realizar el cifrado de un texto
         * @param {PeticionCifrado} [peticionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cifraTexto: async (peticionCifrado?: PeticionCifrado, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas-curp`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof peticionCifrado !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(peticionCifrado !== undefined ? peticionCifrado : {}) : (peticionCifrado || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Método utilizado validar el cifrado de una cadena
         * @param {ValidacionCifrado} [validacionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaCifrado: async (validacionCifrado?: ValidacionCifrado, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/firmas-curp/validate`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["jhipster", "email", "profile"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }

            // authentication openId required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = {...localVarUrlObj.query, ...localVarQueryParameter, ...options.query};
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof validacionCifrado !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(validacionCifrado !== undefined ? validacionCifrado : {}) : (validacionCifrado || "");

            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FirmaCurpApi - functional programming interface
 * @export
 */
export const FirmaCurpApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Método utilizado para realizar el cifrado de un texto
         * @param {PeticionCifrado} [peticionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cifraTexto(peticionCifrado?: PeticionCifrado, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RespuestaCifrado>> {
            const localVarAxiosArgs = await FirmaCurpApiAxiosParamCreator(configuration).cifraTexto(peticionCifrado, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Método utilizado validar el cifrado de una cadena
         * @param {ValidacionCifrado} [validacionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validaCifrado(validacionCifrado?: ValidacionCifrado, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await FirmaCurpApiAxiosParamCreator(configuration).validaCifrado(validacionCifrado, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * FirmaCurpApi - factory interface
 * @export
 */
export const FirmaCurpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Método utilizado para realizar el cifrado de un texto
         * @param {PeticionCifrado} [peticionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cifraTexto(peticionCifrado?: PeticionCifrado, options?: any): AxiosPromise<RespuestaCifrado> {
            return FirmaCurpApiFp(configuration).cifraTexto(peticionCifrado, options).then((request) => request(axios, basePath));
        },
        /**
         * Método utilizado validar el cifrado de una cadena
         * @param {ValidacionCifrado} [validacionCifrado] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validaCifrado(validacionCifrado?: ValidacionCifrado, options?: any): AxiosPromise<boolean> {
            return FirmaCurpApiFp(configuration).validaCifrado(validacionCifrado, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FirmaCurpApi - object-oriented interface
 * @export
 * @class FirmaCurpApi
 * @extends {BaseAPI}
 */
export class FirmaCurpApi extends BaseAPI {
    /**
     * Método utilizado para realizar el cifrado de un texto
     * @param {PeticionCifrado} [peticionCifrado] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaCurpApi
     */
    public cifraTexto(peticionCifrado?: PeticionCifrado, options?: any) {
        return FirmaCurpApiFp(this.configuration).cifraTexto(peticionCifrado, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Método utilizado validar el cifrado de una cadena
     * @param {ValidacionCifrado} [validacionCifrado] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FirmaCurpApi
     */
    public validaCifrado(validacionCifrado?: ValidacionCifrado, options?: any) {
        return FirmaCurpApiFp(this.configuration).validaCifrado(validacionCifrado, options).then((request) => request(this.axios, this.basePath));
    }

}


